import {
	AppBar,
	Dialog,
	IconButton,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';
import indigo from '@material-ui/core/colors/indigo';
import red from '@material-ui/core/colors/red';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { UpwardTransition } from 'src/utils';

import { CMItemCode, isValid } from 'src/utils/CMData';
import { Routes, Screens } from 'src/utils/Routes';
import {
	IApply,
	ICareerSearchCondition,
	ISearchDetailItem,
	ISelectedCareer,
	setApplicationSelectedCareers,
	setCareerSearchCondition,
	setDetailSelectedCareers,
	setSearchDetailForApplySelectedColumns,
	setSearchDetails,
	setSearchDetailSelectedColumns,
} from '../actions/search';
import CareerDetailSearchCondition from '../components/CareerDetailSearchCondition';
import MessageDialog from '../components/MessageDialog';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/SearchScenarioFactory';
import InputCheck from '../utils/InputCheck';
import { getSystemMst, MasterItemCode } from '../utils/MasterData';
import { isMobile } from '../utils/MobileCheck';
import CareerDetail from './CareerDetail';
import CurriculumDetail from './CurriculumDetail';
import SkillDetail from './SkillDetail';

export enum SearchDetailTypes {
	NORMAL,
	APPLY,
}

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		careerDialog: {
			width: '80%',
		},
		checkbox: {
			height: 36,
			width: 36,
		},
		container: {
			borderBottom: `1px solid ${theme.palette.primary.main}`,
			marginBottom: theme.spacing(3),
			paddingBottom: theme.spacing(2),
		},
		contenOver: {
			marginBottom: '50px',
		},
		content: {
			margin: 'auto',
			maxWidth: 700,
		},
		formControl: {
			minWidth: 120,
		},
		hidden: {
			visibility: 'hidden',
		},
		iconAdd: {
			color: green[500],
		},
		iconRemove: {
			color: red[500],
		},
		link: {
			color: indigo[700],
			cursor: 'pointer',
		},
		pointer: {
			cursor: 'pointer',
		},
		right: {
			justifyContent: 'flex-end',
		},
		root: {
			margin: theme.spacing(1),
			padding: theme.spacing(1),
		},
		selectedRow: {
			// background: `radial-gradient(transparent, ${
			// 	theme.palette.primary.light
			// })`,
		},
	});

interface IState {
	dialogContent: string;
	dialogOpen: boolean;
	openSearchDialog: boolean;
	selectColumnsMenuAnchorEl?: HTMLElement;
	openCareerDetailDialog: boolean;
	openCurriculumDetailDialog: boolean;
	openSkillDetailDialog: boolean;
	careerID: string;
	dialogReplacement: string[];
}

/**
 * 詳細検索
 */
class SearchDetail extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			careerID: '',
			dialogContent: '',
			dialogOpen: false,
			dialogReplacement: [],
			openCareerDetailDialog: false,
			openCurriculumDetailDialog: false,
			openSearchDialog: false,
			openSkillDetailDialog: false,
		};

		this.openConfirmDialog = this.openConfirmDialog.bind(this);
		this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
		this.openDialog = this.openDialog.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.showDetail = this.showDetail.bind(this);
		this.showApprovals = this.showApprovals.bind(this);
		this.showResultApplication = this.showResultApplication.bind(this);
		this.checkAll = this.checkAll.bind(this);
		this.clearAll = this.clearAll.bind(this);
	}

	public render() {
		const { classes, data } = this.props;
		const columns = this.getSelectedColumns();
		const mobileColumns = this.getSelectedMobileColumns();

		const selected = this.props.selectedCareers.length;
		const indicator = selected
			? `${selected}${i18n.t('SearchDetail_0001')}`
			: '';
		const cmFlg: boolean = isValid(CMItemCode.CM_ENABLED);

		return (
			<>
				{isMobile() && (
					<>
						<div
							style={{
								backgroundColor: '#e8eaf6',
								bottom: '0px',
								display: 'flex',
								justifyContent: 'center',
								marginLeft:
									this.props.type === SearchDetailTypes.NORMAL
										? '-2.2%'
										: '-4.3%',
								position: 'fixed',
								width: '100%',
								zIndex: 999,
							}}
						>
							{!this.props.resultApply && (
								<Button
									onClick={this.showApprovals}
									variant="contained"
									color="primary"
									style={{
										marginBottom: '2%',
										marginRight: '2%',
										marginTop: '1%',
									}}
								>
									{i18n.t('SearchDetail_0003')}
								</Button>
							)}
						</div>
					</>
				)}
				<Paper className={classes.root}>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
						}}
					>
						<Button
							onClick={this.openDialog}
							variant="contained"
							color="primary"
							className={
								this.props.type === SearchDetailTypes.NORMAL
									? ''
									: classes.hidden
							}
						>
							<SearchIcon />
						</Button>
						{!isMobile() && (
							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
								}}
							>
								{!this.props.resultApply && (
									<Button
										onClick={this.showApprovals}
										variant="contained"
										color="primary"
										className={classes.right}
										style={{ marginRight: '10px' }}
									>
										{cmFlg
											? i18n.t('SearchDetail_0002')
											: i18n.t('SearchDetail_0003')}
									</Button>
								)}
								{(this.props.searchCondition.careerType ===
									'10' ||
									this.props.resultApply) && (
									<Button
										onClick={this.showResultApplication}
										variant="contained"
										color="primary"
										className={classes.right}
									>
										{i18n.t('SearchDetail_0004')}
									</Button>
								)}
							</div>
						)}
						{isMobile() && (
							<>
								<div
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
									}}
								>
									<Button
										onClick={this.checkAll}
										variant="contained"
										color="primary"
										style={{ marginRight: '10px' }}
									>
										{i18n.t('SearchDetail_0026')}
									</Button>
									<Button
										onClick={this.clearAll}
										variant="contained"
										color="primary"
										style={{ marginRight: '5px' }}
									>
										{i18n.t('SearchDetail_0027')}
									</Button>
								</div>
							</>
						)}
					</div>
					{!isMobile() && (
						<>
							<ReactTable
								data={data}
								columns={columns}
								defaultPageSize={10}
								className="-striped -highlight"
								getTrGroupProps={this.getTrGroupProps(classes)}
								indicator={indicator}
								columnsMenu={true}
								menuHandler={this.handleSelectColumns}
							/>
							{this.getSelectColumnsMenu()}
						</>
					)}
					{isMobile() && (
						<>
							<div className={classes.contenOver}>
								<ReactTable
									data={data}
									columns={mobileColumns}
									defaultPageSize={10}
									className="-striped -highlight"
									getTrGroupProps={this.getTrGroupProps(
										classes
									)}
									indicator={indicator}
								/>
							</div>
						</>
					)}

					<CareerDetailSearchCondition
						open={this.state.openSearchDialog}
						onClose={this.closeDialog}
					/>
					<MessageDialog
						open={this.state.dialogOpen}
						showCancelButton={false}
						title={i18n.t('SearchDetail_0005')}
						contents={[
							{
								content: this.state.dialogContent,
								replacements: this.state.dialogReplacement,
							},
						]}
						onClose={this.closeConfirmDialog}
						onClickOk={this.closeConfirmDialog}
					/>
					<Dialog
						fullScreen={false}
						TransitionComponent={UpwardTransition}
						open={this.state.openCareerDetailDialog}
						onClose={this.handlecloseDetailDialog}
						fullWidth={true}
						maxWidth={false}
						classes={{
							paperFullWidth: this.props.classes.careerDialog,
						}}
					>
						<AppBar className={this.props.classes.appBar}>
							<Toolbar>
								<IconButton
									color="inherit"
									aria-label="Close"
									onClick={this.handlecloseDetailDialog}
								>
									<CloseIcon />
								</IconButton>
								<Typography variant="h6" color="inherit">
									{i18n.t('SearchDetail_0006')}
								</Typography>
							</Toolbar>
						</AppBar>
						<CareerDetail careerID={this.state.careerID} />
					</Dialog>
					<Dialog
						fullScreen={false}
						TransitionComponent={UpwardTransition}
						open={this.state.openCurriculumDetailDialog}
						onClose={this.handlecloseDetailDialog}
						fullWidth={true}
						maxWidth={false}
						classes={{
							paperFullWidth: this.props.classes.careerDialog,
						}}
					>
						<AppBar className={this.props.classes.appBar}>
							<Toolbar>
								<IconButton
									color="inherit"
									aria-label="Close"
									onClick={this.handlecloseDetailDialog}
								>
									<CloseIcon />
								</IconButton>
								<Typography variant="h6" color="inherit">
									{i18n.t('SearchDetail_0007')}
								</Typography>
							</Toolbar>
						</AppBar>
						<CurriculumDetail curriculumId={this.state.careerID} />
					</Dialog>
					<Dialog
						fullScreen={false}
						TransitionComponent={UpwardTransition}
						open={this.state.openSkillDetailDialog}
						onClose={this.handlecloseDetailDialog}
						fullWidth={true}
						maxWidth={false}
						classes={{
							paperFullWidth: this.props.classes.careerDialog,
						}}
					>
						<AppBar className={this.props.classes.appBar}>
							<Toolbar>
								<IconButton
									color="inherit"
									aria-label="Close"
									onClick={this.handlecloseDetailDialog}
								>
									<CloseIcon />
								</IconButton>
								<Typography variant="h6" color="inherit">
									{i18n.t('SearchDetail_0008')}
								</Typography>
							</Toolbar>
						</AppBar>
						<SkillDetail skillId={this.state.careerID} />
					</Dialog>
				</Paper>
			</>
		);
	}

	public componentWillUnmount() {
		const newObj: ICareerSearchCondition = {
			assessment: false,
			careerIDs: [],
			careerType: '0',
			categoryId: '',
			categoryName: '',
			detail: [
				{
					__multiselectValues: [],
					__type: '',
					items: [],
					text: '',
					type: '',
				},
			],
			elearning: true,
			endDate: '',
			freeword: '',
			jobCategory: false,
			lowerFlg: false,
			office: false,
			onlyWanted: false,
			position: false,
			qualification: false,
			shugo: true,
			skillTypeList: [],
			sonota: false,
			startDate: '',
			tuusin: true,
			workExperience: false,
		};
		newObj.careerType = this.props.searchCondition.careerType;
		this.props.setCareerSearchCondition(newObj);
		const details = {
			applyFlg: 0,
			data: [],
		};
		this.props.setSearchDetails(details.applyFlg, details.data);
	}

	/**
	 * 行プロパティ
	 */
	protected getTrGroupProps = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}

		const { careerId, classId } = rowInfo.original;
		const isSelected = this.isIncludeSelectedColumns(careerId, classId);
		let className: string = '';
		if (isSelected) {
			className = classes.selectedRow;
		}

		return { className };
	};

	/**
	 * 検索ダイアログ表示
	 */
	protected openDialog = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ openSearchDialog: true });
	};

	/**
	 * 検索ダイアログ非表示
	 */
	protected closeDialog = () => {
		this.setState({ openSearchDialog: false });
		this.changeErrDate();
	};

	/**
	 * チェックボックス制御
	 */
	protected check = (event: React.MouseEvent<HTMLElement>) => {
		const careerId = event.currentTarget.getAttribute('data-careerid');
		const classId = event.currentTarget.getAttribute('data-classid') || '';
		const careerType = event.currentTarget.getAttribute('data-careertype');
		if (careerId && careerId !== '' && careerType && careerType !== '') {
			// 同じcareerId+classIdの組み合わせがあれば除外
			const newSelectedCareers: ISelectedCareer[] = this.props.selectedCareers.filter(
				(selected: ISelectedCareer): boolean => {
					return (
						careerId !== selected.careerId ||
						classId !== selected.classId
					);
				}
			);
			// 除外したものが無ければ追加
			if (
				newSelectedCareers.length === this.props.selectedCareers.length
			) {
				newSelectedCareers.push({
					careerId,
					careerType,
					classId,
				});
			}

			// タイプに応じて分ける
			const { type } = this.props;
			if (type === SearchDetailTypes.NORMAL) {
				this.props.setDetailSelectedCareers(newSelectedCareers);
			} else {
				this.props.setApplicationSelectedCareers(newSelectedCareers);
			}
		}
	};

	/**
	 * カラム表示制御
	 */
	protected getAllColumns() {
		const cmFlg: boolean = isValid(CMItemCode.CM_ENABLED);
		return [
			{
				Cell: (row: RowRenderProps) => {
					const checked = this.isIncludeSelectedColumns(
						row.original.careerId,
						row.original.classId
					);
					return (
						<div>
							{row.original.check !== null && (
								<Checkbox
									className={this.props.classes.checkbox}
									data-careerid={row.original.careerId}
									data-classid={row.original.classId}
									data-careertype={row.original.careerType}
									onClick={this.check}
									checked={checked}
									color="primary"
								/>
							)}
						</div>
					);
				},
				Header: (row: RowRenderProps) => {
					const selectable = this.props.data.filter(
						item => item.check !== null
					);
					const checked =
						selectable.length !== 0 &&
						selectable.length === this.props.selectedCareers.length;
					return (
						<Checkbox
							className={this.props.classes.checkbox}
							onClick={this.checkAllRows}
							checked={checked}
							color="primary"
						/>
					);
				},
				accessor: 'check',
				required: true,
				sortable: false,
				width: 50,
			},
			{
				Header: i18n.t('SearchDetail_0009'),
				accessor: 'managementCode',
				minWidth: 100,
			},
			{
				Cell: (row: RowRenderProps) => {
					return (
						<span
							className={this.props.classes.link}
							data-careerid={row.original.careerId}
							data-careertype={row.original.careerType}
							onClick={this.showDetail}
						>
							{row.original.careerTitle}
						</span>
					);
				},
				Header: cmFlg
					? i18n.t('SearchDetail_0010')
					: i18n.t('SearchDetail_0011'),
				accessor: 'careerTitle',
				minWidth: 120,
			},
			{
				Cell: (row: RowRenderProps) =>
					row.original.classId === 'CL000000'
						? i18n.t(row.value, { ns: 'force' })
						: row.value,
				Header: cmFlg
					? i18n.t('SearchDetail_0012')
					: i18n.t('SearchDetail_0013'),
				accessor: 'className',
				minWidth: 120,
			},
			{
				Cell: (row: RowRenderProps) => {
					const careerType = row.original.careerType;
					const type = row.value;
					if (
						careerType === 0 ||
						careerType === 90 ||
						type === '資格' ||
						type === '業務経験' ||
						type === 'スキル診断'
					) {
						return i18n.t(type, { ns: 'force' });
					} else {
						return type;
					}
				},
				Header: i18n.t('SearchDetail_0014'),
				accessor: 'type',
				minWidth: 60,
			},
			{
				Header: i18n.t('SearchDetail_0015'),
				accessor: 'deadline',
				minWidth: 100,
			},
			{
				Cell: (row: RowRenderProps) => {
					const careerType = row.original.careerType;
					const careerTypeId = row.original.careerTypeId;
					const classId = row.original.classId;
					const endDateByYear = row.original.endDateByYear;
					const endDateByDay = row.original.endDateByDay;
					let period = row.value;
					if (period && period.indexOf('～') !== -1) {
						period = period.replace(
							'～',
							i18n.t('～', {
								ns: 'force',
							})
						);
					}
					if (
						careerType === 0 &&
						careerTypeId === 1 &&
						classId === 'CL000000' &&
						endDateByYear !== null
					) {
						return i18n.t('SearchDetail_0024', {
							endDateByYear,
						});
					} else if (
						careerType === 0 &&
						careerTypeId === 1 &&
						classId === 'CL000000' &&
						endDateByDay !== null
					) {
						return i18n.t('SearchDetail_0025', {
							endDateByDay,
						});
					} else {
						return period;
					}
				},
				Header: cmFlg
					? i18n.t('SearchDetail_0016')
					: i18n.t('SearchDetail_0017'),
				accessor: 'period',
				minWidth: 100,
			},
			{
				Header: i18n.t('SearchDetail_0018'),
				accessor: 'target',
				minWidth: 80,
			},
			{
				Header: i18n.t('SearchDetail_0019'),
				accessor: 'organizer',
				minWidth: 80,
			},
			{
				Header: i18n.t('SearchDetail_0020'),
				accessor: 'place',
				minWidth: 70,
			},
			{
				Header: i18n.t('SearchDetail_0021'),
				accessor: 'cost',
				minWidth: 80,
			},
		];
	}

	protected getAllMobileColumns() {
		return [
			{
				Cell: (row: RowRenderProps) => {
					const checked = this.isIncludeSelectedColumns(
						row.original.careerId,
						row.original.classId
					);
					return (
						<div>
							{row.original.check !== null && (
								<Checkbox
									className={this.props.classes.checkbox}
									data-careerid={row.original.careerId}
									data-classid={row.original.classId}
									data-careertype={row.original.careerType}
									onClick={this.check}
									checked={checked}
									color="primary"
								/>
							)}
						</div>
					);
				},
				Header: ' ',
				accessor: 'check',
				required: true,
				sortable: false,
				width: 40,
			},
			{
				Cell: (row: RowRenderProps) => {
					return (
						<span
							className={this.props.classes.link}
							data-careerid={row.original.careerId}
							data-careertype={row.original.careerType}
							onClick={this.showDetail}
						>
							{row.original.careerTitle}
						</span>
					);
				},
				Header: i18n.t('SearchDetail_0011'),
				accessor: 'careerTitle',
				minWidth: 145,
			},
			{
				Cell: (row: RowRenderProps) =>
					row.original.classId === 'CL000000'
						? i18n.t(row.value, { ns: 'force' })
						: row.value,
				Header: i18n.t('SearchDetail_0013'),
				accessor: 'className',
				minWidth: 105,
			},
		];
	}

	/**
	 * 選択カラム取得
	 */
	protected getSelectedColumns() {
		let columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		const careerTypeControl = getSystemMst(
			MasterItemCode.CAREER_TYPE_CONTROL
		);
		if (careerTypeControl === '0') {
			columns = columns.filter((column: any) => {
				return column.accessor !== 'place';
			});
		}
		return columns;
	}

	protected getSelectedMobileColumns() {
		const columns: any[] = Object.assign([], this.getAllMobileColumns());

		columns.map((column: any) => {
			column.show = true;
		});

		return columns;
	}

	/**
	 * カラム選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		let allColumns = this.getAllColumns();
		const checkboxList: any[] = [];

		const careerTypeControl = getSystemMst(
			MasterItemCode.CAREER_TYPE_CONTROL
		);
		if (careerTypeControl === '0') {
			allColumns = allColumns.filter((column: any) => {
				return column.accessor !== 'place';
			});
		}
		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="select-column-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
								color="primary"
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 表示カラム選択ボタン
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 表示カラム選択メニュークローズ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * 表示カラム変更処理
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}

		if (this.props.type === SearchDetailTypes.NORMAL) {
			this.props.setSearchDetailSelectedColumns(newSelectedColumns);
		} else if (this.props.type === SearchDetailTypes.APPLY) {
			this.props.setSearchDetailForApplySelectedColumns(
				newSelectedColumns
			);
		}
	};

	/**
	 * 行プロパティ作成
	 */
	protected createTrProps = (state: any, rowInfo: RowInfo) => {
		return {
			style: {
				height: 51,
			},
		};
	};

	/**
	 * 詳細表示
	 */
	protected showDetail = (event: React.MouseEvent<HTMLElement>) => {
		const careerId = event.currentTarget.getAttribute('data-careerid');
		const careerType = event.currentTarget.getAttribute('data-careertype');
		if (careerType === '0' && careerId) {
			this.setState({
				careerID: careerId,
				openCareerDetailDialog: true,
			});
		} else if (careerType === '10' && careerId) {
			this.setState({
				careerID: careerId,
				openSkillDetailDialog: true,
			});
		} else if (careerType === '90' && careerId) {
			this.setState({
				careerID: careerId,
				openCurriculumDetailDialog: true,
			});
		}
	};

	protected handlecloseDetailDialog = () => {
		this.setState({
			careerID: '',
			openCareerDetailDialog: false,
			openCurriculumDetailDialog: false,
			openSkillDetailDialog: false,
		});
	};

	/**
	 * 確認ダイアログオープン
	 */
	protected openConfirmDialog(
		dialogContent: string,
		dialogReplacement?: string[]
	) {
		if (dialogReplacement) {
			this.setState({
				dialogContent,
				dialogOpen: true,
				dialogReplacement,
			});
		} else {
			this.setState({ dialogContent, dialogOpen: true });
		}
	}

	/**
	 * 確認ダイアログクローズ
	 */
	protected closeConfirmDialog() {
		this.setState({ dialogContent: '', dialogOpen: false });
	}

	/**
	 * 受講申請画面遷移
	 */
	protected showApprovals = (event: React.MouseEvent<HTMLElement>) => {
		const { selectedCareers, data, applyFlg } = this.props;
		const applies: IApply[] = [];
		const cmFlg: boolean = isValid(CMItemCode.CM_ENABLED);
		// 選択行がない場合はエラー
		if (!selectedCareers || selectedCareers.length === 0) {
			if (cmFlg && !isMobile()) {
				this.openConfirmDialog('LMCM_E_15014');
			} else {
				this.openConfirmDialog('LMCM_E_00235', [
					i18n.t('SearchDetail_0022'),
				]);
			}
			return;
		}
		const selectedCareerIds = this.getSelectedCareerIds();
		const selectedCareerTypes = this.getSelectedCareerTypes();

		// 研修・カリキュラムの両方が選択されていたらエラー
		const containsCareer: boolean = selectedCareerTypes.indexOf('0') !== -1;
		const containsSkill: boolean = selectedCareerTypes.indexOf('10') !== -1;
		const containsCurriculum: boolean =
			selectedCareerTypes.indexOf('90') !== -1;
		if (containsCareer && containsCurriculum) {
			this.openConfirmDialog('LMCM_E_00511');
			return;
		}

		// 対象ユーザのコース申込不可フラグが1の場合はエラー
		if (applyFlg === 1) {
			this.openConfirmDialog('LMCM_E_00541');
			return;
		}

		if (containsSkill) {
			// スキル場合、チェックメッセージを表示する。
			const msgObj = this.getCheckMessageId(selectedCareers, data, 2);
			if (msgObj) {
				this.openConfirmDialog(msgObj.msgId, msgObj.msgParams);
				return;
			}
		}

		// 同一キャリアが複数チェックされている場合はエラー
		const duplicatedCareerIds = selectedCareerIds.filter(
			(id: string, i: number, self) =>
				self.indexOf(id) === i && self.lastIndexOf(id) !== i
		);
		if (duplicatedCareerIds.length > 0) {
			if (containsSkill) {
				// 同一スキルが複数チェックされている場合はエラー
				this.openConfirmDialog('LMCM_E_15019');
				return;
			} else {
				// 複数スキルを選択して、実績ボタンをクリックする時
				this.openConfirmDialog('LMCM_E_00288');
				return;
			}
		}

		// システム申込とWeb申込をカウント
		let webAppCount = 0;
		let systemAppCount = 0;
		let referenceURL = '';
		data.map((detail: ISearchDetailItem) => {
			const { careerId, classId = '' } = detail;
			if (careerId && this.isIncludeSelectedColumns(careerId, classId)) {
				applies.push({
					approverId1: '',
					approverId2: '',
					approverId4: '',
					cancelWaitFlg: false,
					careerId,
					classId,
					stayMealData: [],
				});
				if (detail.webAppFlg === '1') {
					webAppCount++;
					referenceURL = detail.referenceURL || '';
				} else {
					systemAppCount++;
				}
			}
		});
		// Web申込が2件以上、またはWeb申込とシステム申込が混在している場合はエラー
		if (webAppCount >= 2 || (webAppCount === 1 && systemAppCount >= 1)) {
			this.openConfirmDialog('LMCM_E_00591');
			return;
		} else if (webAppCount === 1) {
			// Web申込み1件の場合は別タブにて表示
			window.open(referenceURL, '_blank');
			return;
		}

		const careerType = containsCareer ? '0' : containsSkill ? '10' : '90';
		this.props.onApply(applies, careerType);
	};

	/**
	 * 実績申請画面遷移
	 */
	protected showResultApplication = (
		event: React.MouseEvent<HTMLElement>
	) => {
		const { selectedCareers, data } = this.props;
		const selectedCareerTypes = this.getSelectedCareerTypes();
		const containsSkill: boolean = selectedCareerTypes.indexOf('10') !== -1;
		// 選択行がない場合はエラー
		if (!selectedCareers || selectedCareers.length === 0) {
			this.openConfirmDialog('LMCM_E_00235', [
				i18n.t('SearchDetail_0023'),
			]);
			return;
		}

		if (containsSkill) {
			if (selectedCareers.length > 1) {
				// 複数スキルを選択して、実績ボタンをクリックする時
				this.openConfirmDialog('LMCM_E_15013');
				return;
			}
		}

		const msgObj = this.getCheckMessageId(selectedCareers, data, 1);
		if (msgObj) {
			this.openConfirmDialog(msgObj.msgId, msgObj.msgParams);
			return;
		}
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
		to = to.replace(/\/:career_id/, `/${selectedCareers[0].careerId}`);
		to = to.replace(/\/:class_id/, `/${selectedCareers[0].classId}`);
		to = to.replace(/\/:nittei_only_flg/, `/0`);
		let path = window.location.pathname;
		if (path === Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION)) {
			path = Routes.getPath(Screens.PERSONAL_SEARCH);
		}
		this.props.pushHistoryState(to, {
			caller: this.props.resultApply ? this.props.caller : path,
			skillViewFlg: selectedCareers[0].careerType === '10',
		});
	};

	/**
	 * 選択中の研修ID取得
	 */
	protected getSelectedCareerIds() {
		const { selectedCareers } = this.props;
		return selectedCareers.map(
			(selected: ISelectedCareer): string => {
				return selected.careerId;
			}
		);
	}

	/**
	 * 選択中の研修タイプ取得
	 */
	protected getSelectedCareerTypes() {
		const { selectedCareers } = this.props;
		return selectedCareers.map(
			(selected: ISelectedCareer): string => {
				return selected.careerType;
			}
		);
	}

	/**
	 * 選択済みかどうかをチェック
	 * @param careerId 研修ID
	 * @param classId クラスID
	 */
	protected isIncludeSelectedColumns(careerId: string, classId: string) {
		let isInclude = false;
		for (const selected of this.props.selectedCareers) {
			if (selected.careerType === '0') {
				if (
					selected.careerId === careerId &&
					selected.classId === classId
				) {
					isInclude = true;
					break;
				}
			} else if (selected.careerType === '10') {
				if (
					selected.careerId === careerId &&
					selected.classId === classId
				) {
					isInclude = true;
					break;
				}
			} else if (selected.careerType === '90') {
				if (selected.careerId === careerId) {
					isInclude = true;
					break;
				}
			}
		}
		return isInclude;
	}

	/**
	 * 全選択チェックボックス制御
	 */
	protected checkAllRows = (event: React.MouseEvent<HTMLElement>) => {
		const careers: ISelectedCareer[] = [];
		const selectable = this.props.data.filter(item => item.check !== null);
		if (this.props.selectedCareers.length !== selectable.length) {
			// 全選択
			for (const item of selectable) {
				const { careerId } = item;
				const careerType =
					item.careerType === undefined
						? undefined
						: item.careerType + '';
				const classId =
					item.classId === undefined ? undefined : item.classId + '';
				if (careerId && careerType && classId) {
					careers.push({ careerId, careerType, classId });
				}
			}
		}

		// タイプに応じて分ける
		const { type } = this.props;
		if (type === SearchDetailTypes.NORMAL) {
			this.props.setDetailSelectedCareers(careers);
		} else {
			this.props.setApplicationSelectedCareers(careers);
		}
	};

	/**
	 * 全選択チェックボックス制御
	 */
	protected checkAll = (event: React.MouseEvent<HTMLElement>) => {
		const careers: ISelectedCareer[] = [];
		const selectable = this.props.data.filter(item => item.check !== null);
		if (this.props.selectedCareers.length !== selectable.length) {
			// 全選択
			for (const item of selectable) {
				const { careerId } = item;
				const careerType =
					item.careerType === undefined
						? undefined
						: item.careerType + '';
				const classId =
					item.classId === undefined ? undefined : item.classId + '';
				if (careerId && careerType && classId) {
					careers.push({ careerId, careerType, classId });
				}
			}
			// タイプに応じて分ける
			const { type } = this.props;
			if (type === SearchDetailTypes.NORMAL) {
				this.props.setDetailSelectedCareers(careers);
			} else {
				this.props.setApplicationSelectedCareers(careers);
			}
		}
	};

	/**
	 * 全選択チェックボックス制御
	 */
	protected clearAll = (event: React.MouseEvent<HTMLElement>) => {
		const careers: ISelectedCareer[] = [];
		// タイプに応じて分ける
		const { type } = this.props;
		if (type === SearchDetailTypes.NORMAL) {
			this.props.setDetailSelectedCareers(careers);
		} else {
			this.props.setApplicationSelectedCareers(careers);
		}
	};

	/**
	 * 不正な日付を削除する
	 */
	protected changeErrDate = () => {
		const newObj: ICareerSearchCondition = {
			...this.props.searchCondition,
		};
		let dateErrFlg: boolean = false;
		if (
			this.props.searchCondition.startDate &&
			InputCheck.chkErYYYYMMDDhhmm(
				InputCheck.convertDate(this.props.searchCondition.startDate)
			)
		) {
			newObj['startDate'] = '';
			dateErrFlg = true;
		} else if (
			this.props.searchCondition.startDate &&
			(this.props.searchCondition.startDate < '1900/01/01 00:00' ||
				this.props.searchCondition.startDate > '2100/01/01 23:59')
		) {
			newObj['startDate'] = '';
			dateErrFlg = true;
		}
		if (
			this.props.searchCondition.endDate &&
			InputCheck.chkErYYYYMMDDhhmm(
				InputCheck.convertDate(this.props.searchCondition.endDate)
			)
		) {
			newObj['endDate'] = '';
			dateErrFlg = true;
		} else if (
			this.props.searchCondition.endDate &&
			(this.props.searchCondition.endDate < '1900/01/01 00:00' ||
				this.props.searchCondition.endDate > '2100/01/01 23:59')
		) {
			newObj['endDate'] = '';
			dateErrFlg = true;
		}
		if (dateErrFlg) {
			this.props.setCareerSearchCondition(newObj);
		}
	};

	private getCheckMessageId = (
		selectedCareers: ISelectedCareer[],
		data: ISearchDetailItem[],
		type: number
	): any => {
		let msgObj: any = null;

		const selectedDatas = data.filter(obj => {
			const findList = selectedCareers.filter(career => {
				return (
					career.careerId === obj.careerId &&
					career.classId === obj.classId
				);
			});
			return findList.length > 0;
		});

		if (selectedDatas.length > 0) {
			const datas = selectedDatas.filter(obj => {
				return (
					Number(obj.checkFlag) === type &&
					!(
						obj.msgId === '' ||
						obj.msgId == null ||
						obj.msgId === undefined
					)
				);
			});
			if (datas.length > 0) {
				msgObj = {
					msgId: datas[0].msgId,
					msgParams: datas[0].msgParams,
				};
			}
		}
		return msgObj;
	};
}

const mapStateToProps = (state: IRootState) => ({
	careerCategoryMsts: state.search.careerCategoryMsts,
	curriculumCategoryMsts: state.search.curriculumCategoryMsts,
	searchCondition: state.search.careerSearchCondition,
	searchConditionDispInfo: state.search.careerSearchConditionDispInfo,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchDetailCareerList: (
		token: string,
		condition: ICareerSearchCondition
	) => {
		const s = ScenarioFactory.createFetchDetailCareerList(dispatch, token);
		s.run(condition);
	},
	fetchSearchConditionDispInfo: (token: string) => {
		const s = ScenarioFactory.createFetchSearchConditionDispInfo(
			dispatch,
			token
		);
		s.run({});
	},
	pushHistory: (path: string, state?: any) => dispatch(push(path, state)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setApplicationSelectedCareers: (selectedCareers: ISelectedCareer[]) =>
		dispatch(setApplicationSelectedCareers({ selectedCareers })),
	setCareerSearchCondition: (value: ICareerSearchCondition) =>
		dispatch(setCareerSearchCondition({ value })),
	setDetailSelectedCareers: (selectedCareers: ISelectedCareer[]) =>
		dispatch(setDetailSelectedCareers({ selectedCareers })),
	setSearchDetailForApplySelectedColumns: (selectedColumns: number[]) =>
		dispatch(setSearchDetailForApplySelectedColumns({ selectedColumns })),
	setSearchDetailSelectedColumns: (selectedColumns: number[]) =>
		dispatch(setSearchDetailSelectedColumns({ selectedColumns })),
	setSearchDetails: (applyFlg: number, data: ISearchDetailItem[]) =>
		dispatch(setSearchDetails({ applyFlg, data })),
});

export interface ISearchDetailProp {
	applyFlg: number;
	data: ISearchDetailItem[];
	type: SearchDetailTypes;
	selectedCareers: ISelectedCareer[];
	selectedColumns: number[];
	onApply: (applies: IApply[], careerType: string) => void;
	resultApply: boolean;
	caller?: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISearchDetailProp;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SearchDetail);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/SearchDetail.tsx